import { defineComponent, inject, ref, computed, watch, nextTick, openBlock, createElementBlock, mergeProps, renderSlot, createCommentVNode, createElementVNode, withDirectives, Fragment, renderList, createVNode, normalizeClass, vShow, unref, normalizeStyle, isRef, vModelDynamic, withModifiers, toDisplayString } from "vue";
import CloseCircleIcon from "../../assets/icons/close-circle.svg.js";
import InformationCircleStrokeRoundedIcon from "../../assets/icons/outline/information-circle-stroke-rounded.svg.js";
import { useFormControl } from "../../composables/useFormControl.js";
import Badge from "../badge/Badge.vue.js";
import { SELECT_KEY } from "../select/type.js";
const _hoisted_1 = { class: "input-field" };
const _hoisted_2 = {
  key: 0,
  class: "input__prefix"
};
const _hoisted_3 = {
  key: 0,
  class: "input__placeholder"
};
const _hoisted_4 = {
  key: 1,
  class: "input__suffix"
};
const _hoisted_5 = {
  key: 0,
  class: "input__prefix"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  key: 2,
  class: "input__suffix"
};
const _hoisted_8 = {
  key: 2,
  class: "input__hint"
};
const _hoisted_9 = { class: "input__hint-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "Input",
  props: {
    size: { default: "sm" },
    disabled: { type: Boolean, default: false },
    contentType: { default: "text" },
    modelValue: {},
    textWrapperClass: {},
    textContentClass: {},
    textInputClass: {},
    rounded: {},
    clearable: { type: Boolean, default: false },
    hint: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const { onOptionRemoved } = inject(SELECT_KEY, {});
    const props = __props;
    const { size, hasError, hasHint, hintText, model } = useFormControl(props, emit);
    const inputRef = ref(null);
    const isFocused = ref(false);
    const isHovered = ref(false);
    const handleFocus = () => {
      isFocused.value = true;
    };
    const handleBlur = () => {
      setTimeout(() => {
        isFocused.value = false;
      }, 150);
    };
    const handleClear = () => {
      model.value = "";
      emit("update:modelValue", "");
      inputRef.value?.focus();
    };
    const parentRef = ref(null);
    const childRef = ref(null);
    const countRef = ref(null);
    const countItems = ref(0);
    const handleClose = (event, option) => {
      event.stopPropagation();
      onOptionRemoved?.(option);
    };
    const showItems = computed(() => {
      if (countItems.value === 0) return model.value;
      const index = model.value.length - countItems.value;
      return model.value?.slice(0, index);
    });
    const hasOption = computed(() => {
      return model.value?.length;
    });
    const inputClasses = computed(() => {
      return [
        "input",
        `input--${size.value}`,
        { "has-error": hasError?.value ?? false },
        { "has-hint": hasHint.value },
        { disabled: props.disabled }
      ];
    });
    const inputStyles = computed(() => {
      const roundedValue = props.rounded?.trim();
      if (!roundedValue) {
        return {};
      }
      if (roundedValue.startsWith("var(") || roundedValue === "0" || /^\d/.test(roundedValue)) {
        return { "--input-radius": roundedValue };
      }
      return { "--input-radius": `var(--radius-${roundedValue})` };
    });
    watch(
      model,
      async (oldValue, newValue) => {
        if (!parentRef.value || !childRef.value) return;
        await nextTick();
        const parentStyle = getComputedStyle(parentRef.value);
        const parentWidth = parentRef.value.clientWidth - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight);
        const childWidth = childRef.value?.scrollWidth;
        const countWidth = countRef.value?.scrollWidth || 0;
        console.log("countWidth", countWidth);
        if (oldValue?.length > newValue?.length) {
          if (parentWidth < childWidth + countWidth) {
            countItems.value += 1;
          }
        } else {
          countItems.value = countItems.value ? countItems.value - 1 : 0;
        }
      },
      { immediate: true }
    );
    __expose({
      ref: inputRef,
      input: inputRef
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        __props.contentType === "tags" ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          tabindex: "0",
          class: ["input__tags", inputClasses.value],
          style: inputStyles.value
        }, _ctx.$attrs), [
          _ctx.$slots.prefix ? (openBlock(), createElementBlock("div", _hoisted_2, [
            renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            ref_key: "parentRef",
            ref: parentRef,
            class: "input__content"
          }, [
            withDirectives(createElementVNode("div", {
              ref_key: "childRef",
              ref: childRef,
              class: "flex gap-1.5"
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(showItems.value, (item) => {
                return openBlock(), createElementBlock("div", {
                  key: item,
                  class: "flex"
                }, [
                  createVNode(Badge, {
                    label: item,
                    size: "sm",
                    variant: "grey",
                    closeable: "",
                    onClose: (event) => handleClose(event, item)
                  }, null, 8, ["label", "onClose"])
                ]);
              }), 128)),
              createElementVNode("div", {
                ref_key: "countRef",
                ref: countRef,
                class: normalizeClass(["flex", countItems.value > 0 ? "opacity-100" : "opacity-0"])
              }, [
                createVNode(Badge, {
                  label: `+${countItems.value}`,
                  size: "sm",
                  variant: "grey"
                }, null, 8, ["label"])
              ], 2)
            ], 512), [
              [vShow, unref(model)?.length > 0]
            ]),
            !hasOption.value ? (openBlock(), createElementBlock("span", _hoisted_3, " No options ")) : createCommentVNode("", true)
          ], 512),
          _ctx.$slots.suffix ? (openBlock(), createElementBlock("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 16)) : (openBlock(), createElementBlock("div", {
          key: 1,
          tabindex: "0",
          class: normalizeClass(["input__text", inputClasses.value, __props.textWrapperClass]),
          style: normalizeStyle(inputStyles.value),
          onMouseenter: _cache[2] || (_cache[2] = ($event) => isHovered.value = true),
          onMouseleave: _cache[3] || (_cache[3] = ($event) => isHovered.value = false)
        }, [
          _ctx.$slots.prefix ? (openBlock(), createElementBlock("div", _hoisted_5, [
            renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["input__content", __props.textContentClass])
          }, [
            withDirectives(createElementVNode("input", mergeProps({
              ref_key: "inputRef",
              ref: inputRef,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(model) ? model.value = $event : null),
              class: __props.textInputClass,
              disabled: __props.disabled
            }, _ctx.$attrs, {
              onFocus: handleFocus,
              onBlur: handleBlur
            }), null, 16, _hoisted_6), [
              [vModelDynamic, unref(model)]
            ])
          ], 2),
          __props.clearable && unref(model) && !__props.disabled && (isFocused.value || isHovered.value) ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "input__clear",
            onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {
            }, ["prevent"])),
            onClick: handleClear
          }, [
            createVNode(unref(CloseCircleIcon))
          ], 32)) : createCommentVNode("", true),
          _ctx.$slots.suffix ? (openBlock(), createElementBlock("div", _hoisted_7, [
            renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 38)),
        unref(hasHint) ? (openBlock(), createElementBlock("div", _hoisted_8, [
          createVNode(unref(InformationCircleStrokeRoundedIcon), { class: "input__hint-icon" }),
          createElementVNode("span", _hoisted_9, toDisplayString(unref(hintText)), 1)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Input.vue2.js.map
